// extracted by mini-css-extract-plugin
export default {"toolbar":"style_toolbar__JF3Gk","host":"style_host__Ev8Mn","approvals":"style_approvals__L+RJW"};